<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :tableTotal="tableTotal"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template v-slot:button>
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="export-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile()"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="pushInv"
            v-if="allow('I')"
          >
            {{ $l('btn_push_inv') || '推送库存' }}
          </b-button>
        </template>
      </PageHeader>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="evgBizLcInvList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-evgLcInv' }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/ecom/components/choose-template'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SortFieldsPopover, chooseTemplate },
  data() {
    return {
      usePage: true,
      sortFields: [],
      checkedRows: [],
      currSearchForm: {},
      chooseTemplateOptions: { visible: false },
      tableTotal: {},
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loadTableData(form)
      this.loadTableTotal(form)
    },
    pushInv() {
      this.$confirm(
        this.$l('tips_confirm_push_inv') || '是否推送库存记录',
        this.$l('tip_confirm_push_inv_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_push_inv_confirm') || '确定',
          cancelButtonText: this.$l('btn_push_inv_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvPushApi()
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(
            this.$l('tips_push_inv_error') || '推送失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_push_inv_success') || '推送成功！',
          type: 'success',
        })
      })
    },
    loadTableData(form) {
      this.loading = true
      this.$api
        .ecomOverseasInvListApi({
          ...form,
          ...this.page,
          sortFields: this.sortFields,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.currSearchForm = form
          // this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    async loadTableTotal(form) {
      const res = await this.$api
        .ecomOverseasInvSelectTotalApi(form)
        .catch(() => null)
      this.tableTotal = { ...((res || {}).body || {}) }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    exportFile() {
      if (!this.tableData || !this.tableData.length) {
        this.$message({
          message:
            this.$l('tips_exportEmptyData') ||
            '当前条件无匹配库存数据，请修改查询后重试！',
          type: 'warning',
        })
        return
      }

      const listCode = this.checkedRows?.map((item) => item.invKey) || []
      const searchForm = {
        ...this.currSearchForm,
        sortFields: this.sortFields,
        listCode,
      }

      this.chooseTemplateOptions = { visible: true, searchForm }
    },
  },
}
</script>
<style lang="scss" scoped>
.export-button {
  .el-icon-circle-close {
    display: none;
  }
}
.export-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
